module.exports = __webpack_public_path__ + "static/AddNote-625fbd9f928a80d4a3c04f50424818dd.gif";